export const languages = [
  {
    langId: 'it-IT',
    title: 'Italiano',
    flag: '/img/flags/it.svg',
    code: 'it',
  },
  {
    langId: 'en-GB',
    title: 'English',
    // title: 'English(UK)',
    flag: '/img/flags/en.svg',
    code: 'EN',
  },
  // {
  //   langId: 'en-US',
  //   title: 'English(US)',
  //   // title: 'American',
  //   flag: '/img/flags/us.svg',
  //   code: 'US',
  // },
  {
    langId: 'de-DE',
    title: 'Deutsch',
    flag: '/img/flags/de.svg',
    code: 'de',
  },
  {
    langId: 'es-ES',
    title: 'Español',
    flag: '/img/flags/es.svg',
    code: 'es',
  },
  {
    langId: 'fr-FR',
    title: 'Français',
    flag: '/img/flags/fr.svg',
    code: 'fr',
  },
  // {
  //   langId: 'nl-NL',
  //   title: 'Nederlands',
  //   flag: '/img/flags/nl.svg',
  //   code: 'nl',
  // },
  // {
  //   langId: 'pl-PL',
  //   title: 'Polski',
  //   flag: '/img/flags/pl.svg',
  //   code: 'pl',
  // },
  // {
  //   langId: 'pt-PT',
  //   title: 'Português',
  //   flag: '/img/flags/pt.svg',
  //   code: 'pt',
  // },
  {
    langId: 'ru-RU',
    title: 'Русский',
    flag: '/img/flags/ru.svg',
    code: 'ru',
  },
]
